import { Component, Input } from '@angular/core'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { SharedService } from '../../../services/shared.service'
import { BasicDocumentDTOExtended, VehicleDocumentsService } from '../../../services/vehicle-documents.service'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-offer-contract-info',
  standalone: true,
  templateUrl: './offer-contract-info.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class OfferContractInfoComponent {
  showPreview = false
  showDocumentPrice = false

  document: BasicDocumentDTOExtended
  @Input() set setDocument (document: BasicDocumentDTOExtended) {
    this.document = document
    this.showDocumentPrice = this.showPriceNotUnderGuarantee(document)
    if (document != null) {
      if (this.document.contractType === 'invoice') {
        this.showPreview = false
      } else {
        this.showPreview = true
      }
      // theres a bug in currency pipe if we have negative number
      // https://github.com/angular/angular/issues/46038
      if (
        document.price != null &&
        document.currencyIso != null &&
        document.price < 0
      ) {
        document.currencyIso = document.currencyIso + ' '
      }
    }
  }

  currencySymbol: string
  currency: string
  currencyLocale: string
  dateFormat: string
  hasNewFooter
  units

  constructor (
    public sharedService: SharedService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>,
    private readonly vehicleDocumentsService: VehicleDocumentsService
  ) {
    this.currencySymbol = this.remoteConfigService.get('currencySymbol')
    this.currency = this.remoteConfigService.get('currency')
    this.currencyLocale = this.remoteConfigService.get('currencyLocale')
    this.hasNewFooter = this.remoteConfigService.get('hasNewFooter')
    this.dateFormat = this.remoteConfigService.get('dateFormat.long')

    this.units = {
      currencySymbol: this.currencySymbol,
      currency: this.currency,
      currencyLocale: this.currencyLocale
    }
  }

  hasServices (document: BasicDocumentDTOExtended): boolean {
    return document?.services?.length > 0
  }

  showPriceNotUnderGuarantee (document: BasicDocumentDTOExtended): boolean {
    return this.vehicleDocumentsService.showPriceAndButtonsNotUnderGuarantee(document)
  }
}
